// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 164 ? "chart" : chunkId) + ".bundle.3cd48f14b6821810df7e2a759d218cbf3a02a73c.js";
};